import { ASSIST_API, requestParams } from 'services/assist-api/axios';
import type { BaseCluster } from 'services/assist-api/entities/customer-groups/customer-groups';
import type { BaseOrganisation } from 'services/assist-api/entities/customers/customers';
import type { AssistQuery } from 'services/assist-api/query';
import { useQueryAssist } from 'services/assist-api/query-client';

export type BaseClusterCustomer = API_JSON & {
  customer: API_JSON & Pick<BaseOrganisation, 'name' | 'identifier'>;
};

export type ClusterCustomerWithCustomerGroup = BaseClusterCustomer & { customerGroup: BaseCluster };

const order = { 'order[name]': 'desc' } as const;
const include = 'customer';
const groups = ['customergroupscustomers-customer', 'customer-name'];

/**
 * Fetch cluster customers
 * @param params can be used to customise/limit the organisations retrieved
 * @returns an array of organisations
 */
export const getClusterCustomers: GetMany<BaseClusterCustomer> = async (params) =>
  (
    await ASSIST_API.get('customer-groups-customers', {
      params: requestParams({ order, groups, include }, params)
    })
  ).data;

/**
 * Hook implementation to fetch cluster customers
 *  - caches data
 *  - loading, error, etc
 * @param params additional options to filter the request
 * @returns customers matching request
 */
export const useClusterCustomers: AssistQuery.UseMany<BaseClusterCustomer> = (params, options) =>
  useQueryAssist(['customer-groups-customers', params], () => getClusterCustomers(params), options);
